import { api } from "./api";

export const branchRegister = async (body: any) => {
  const { data } = await api.post("/branches", body);
  return data;
};

export const branchList = async (params: any = {}) => {
  const { data } = await api.get("/branches", { params });
  return data;
};

export const branchSwitch = async (body: any) => {
  const { data } = await api.post("/branches/switch", body);
  return data;
};
